import { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "../shared/pages/ProtectedRoute";
import { AppLayout } from "../shared/layouts";
import { ROUTES } from "../shared/utils";
import { Geospatial } from "../features/geospatial";
import { RisksList, RiskDetail } from "../features/risks";
import { SightingsList, SightingDetail } from "../features/sightings";
import { WorkOrdersList, WorkOrderDetail } from "../features/workorders";

// Placeholder components for routes not yet implemented
const PlaceholderPage = ({ title }: { title: string }) => (
  <div style={{ padding: 24 }}>
    <h2>{title}</h2>
    <p>This page is under construction.</p>
  </div>
);

export const operationalRoutes: RouteObject[] = [
  {
    element: <ProtectedRoute />,
    children: [
      // Geospatial
      {
        element: <AppLayout title="Geospatial" />,
        children: [{ path: ROUTES.GEOSPATIAL, element: <Geospatial /> }],
      },
      // Risks & Alerts
      {
        element: <AppLayout title="Risks & Alerts" />,
        children: [
          { path: ROUTES.RISKS, element: <RisksList /> },
          { path: ROUTES.RISK_DETAIL, element: <RiskDetail /> },
        ],
      },
      // Sightings
      {
        element: <AppLayout title="Sightings" />,
        children: [
          { path: ROUTES.SIGHTINGS, element: <SightingsList /> },
          { path: ROUTES.SIGHTING_DETAIL, element: <SightingDetail /> },
        ],
      },
      // Work Orders
      {
        element: <AppLayout title="Work Orders" />,
        children: [
          { path: ROUTES.WORK_ORDERS, element: <WorkOrdersList /> },
          { path: ROUTES.WORK_ORDER_DETAIL, element: <WorkOrderDetail /> },
        ],
      },
      // Dispatch
      {
        element: <AppLayout title="Dispatch" />,
        children: [{ path: ROUTES.DISPATCH, element: <PlaceholderPage title="Dispatch Console" /> }],
      },
      // Nodes
      {
        element: <AppLayout title="Nodes" />,
        children: [{ path: ROUTES.NODES, element: <PlaceholderPage title="Nodes" /> }],
      },
      // Reports
      {
        element: <AppLayout title="Reports" />,
        children: [{ path: ROUTES.REPORTS, element: <PlaceholderPage title="Reports" /> }],
      },
      // AI Assistant
      {
        element: <AppLayout title="AI Assistant" />,
        children: [{ path: ROUTES.AI_ASSISTANT, element: <PlaceholderPage title="AI Assistant" /> }],
      },
      // Users
      {
        element: <AppLayout title="Users" />,
        children: [{ path: ROUTES.USERS, element: <PlaceholderPage title="Users" /> }],
      },
      // Settings
      {
        element: <AppLayout title="Settings" />,
        children: [{ path: ROUTES.SETTINGS, element: <PlaceholderPage title="Settings" /> }],
      },
    ],
  },
];
